import request from '@/utils/request.js';

// 查询订单列表
export const listOrder = (pageData, formData) => {
    return request.post(`/admin/order/${pageData.page}/${pageData.pageSize}`, formData);
}

// 查询订单详情
export const detailOrder = (orderId) => {
    return request.get(`/admin/order/${orderId}`);
}

// 更新订单状态
export const updateOrderState = (orderId, formData) => {
    return request.put(`/admin/order/state/${orderId}?orderTrigger=${formData.orderTrigger}`);
}

// 所有订单列表
export const listOrderAll = (pageData, formData) => {
    return request.post(`/admin/order/all/${pageData.page}/${pageData.pageSize}`, formData);
}
